// todo: gestion des fermetures des panneaux enfants et petits enfants
var SubnavComplex = function(options) {
  this.options = {
    $el: false,
  };

  $.extend(true, this.options, options);
};

SubnavComplex.prototype.init = function() {
  var self = this;

  self.$items = self.options.$el.find('[data-item-index]');
  self.$submenuItems = self.options.$el.find('[data-submenu-index]');
  self.$childPanel = self.options.$el.find('[data-subnav-child-panel]');
  self.$grandChildPanel = self.options.$el.find('[data-subnav-grandchild-panel]');
  self.$primaryPanel = self.options.$el.find('[data-subnav-primary-panel]');
  self.$secondaryPanel = self.options.$el.find('[data-subnav-secondary-panel]');

  self.$items.each((i, el) => {
    const $item = $(el);
    const itemIndex = $item.data('item-index');
    const $submenuItem = self.$submenuItems
      .filter(`[data-submenu-index="${itemIndex}"]`)
      .one();

    $item.on('mouseenter', () => {
      self.$submenuItems.removeClass('active');
      self.$items.removeClass('active');

      $item.addClass('active');
      $submenuItem.addClass('active');
    });

    // handle child panels
    handleChildPanel($submenuItem, 'children', self.$childPanel);

  });

  // on mouse enter on primary panel, close child and grandchild panels
  self.$primaryPanel.on('mouseenter', (e) => {
    self.$childPanel.removeClass('active');
    self.$grandChildPanel.removeClass('active');
  });

  // on mouse enter on secondary panel, close grandchild panel
  self.$secondaryPanel.on('mouseenter', (e) => {
    self.$grandChildPanel.removeClass('active');
    
  });

  // highlight active items
  self.$secondaryPanel.find('.el-SubnavComplex__secondary__menu__item').on('mouseenter', function() {
    self.$secondaryPanel.find('[data-subnav-children-trigger]').removeClass('active');
    self.$childPanel.find('[data-subnav-children-trigger]').removeClass('active');
    self.$grandChildPanel.find('[data-subnav-grandchildren-trigger]').removeClass('active');
    const $childTrigger = $(this).find('[data-subnav-children-trigger]');
    if ($childTrigger.length) {
      $childTrigger.addClass('active');
    }


    self.$childPanel.find('.el-SubnavComplex-children__subnav__menu__item').on('mouseenter', function() {
      self.$childPanel.find('[data-subnav-grandchildren-trigger]').removeClass('active');
      const $grandChildTrigger = $(this).find('[data-subnav-grandchildren-trigger]');
      if ($grandChildTrigger.length) {
        $grandChildTrigger.addClass('active');
      }
    });

  });

  
  // handle child panels
  function handleChildPanel(parentElt, panelLevel, panelElt) {
    const triggerName = `data-subnav-${panelLevel}-trigger`;
    const items = `data-subnav-${panelLevel}-items`;

    const $triggers = parentElt.find(`[${triggerName}]`);

    $triggers.each((i, el) => {
      const $trigger = $(el);

      const trigger = $trigger.data(triggerName.replace('data-', ''));
      const $items = parentElt.find(`[${items}="${trigger}"]`)

      // siblings without children
      const $siblings = $trigger.parent().siblings().filter((i, sibling) => {
        return $(sibling).find(`[${triggerName}]`).length === 0;
      });
  
      $trigger.on('mouseenter', () => {
        // add items content to panel
        panelElt.empty().append($items.contents().clone());
        panelElt.addClass('active');
        console.log('mouseenter active', panelElt);
        handleChildPanel(self.$childPanel, 'grandchildren', self.$grandChildPanel);
        
      });

      $trigger.on('mouseleave', (e) => {
        // remove active class except if mouse leave on right side
        const rect = el.getBoundingClientRect();
        const x = e.clientX;
        if (x > rect.right + 10) {
          panelElt.removeClass('active');
          if (self.$grandChildPanel.hasClass('active')) {
            self.$grandChildPanel.removeClass('active');
          }
        }
      });

  
      $siblings.on('mouseenter', (e) => {
        panelElt.removeClass('active');
        // check if grandchild panel is open
        if (self.$grandChildPanel.hasClass('active')) {
          self.$grandChildPanel.removeClass('active');
        }
      });
    });
  };

}

export default SubnavComplex;
